export const ASSETS = {
  hero: "https://static.prod-images.emergentagent.com/jobs/a33555ea-bdcc-4cde-8c09-cc24bae8f797/images/e6d5f5a6d974c6d82391f21f63c9f33704a6b8a96ecbb25e853869035b746666.png",
  proofChart: "https://static.prod-images.emergentagent.com/jobs/a33555ea-bdcc-4cde-8c09-cc24bae8f797/images/b9a1ef360870940c8501564d3e32975692b33fcaf14ff139e1190a4e29b82cfb.png",
  computer: "/algo-core.mp4",
  computerPoster: "/algo-core-poster.jpg",
  scanner: "https://customer-assets-cm19k8pv.emergentagent.net/job_crypto-verified-edge/artifacts/2hq45vpk_CleanShot%202026-07-15%20at%2011.50.16%402x.webp",
  intel: "https://customer-assets-cm19k8pv.emergentagent.net/job_crypto-verified-edge/artifacts/0nze882b_CleanShot%202026-07-15%20at%2011.51.05%402x.webp",
  screener: "https://customer-assets-cm19k8pv.emergentagent.net/job_crypto-verified-edge/artifacts/k74txc75_CleanShot%202026-07-15%20at%2011.51.52%402x.webp",
};

export const NAV_LINKS = [
  { label: "How it works", href: "#how" },
  { label: "Engine", href: "#engine" },
  { label: "Order Flow", href: "/order-flow" },
  { label: "Verified", href: "#verified" },
  { label: "Referral", href: "/referral" },
];

export const EBOOKS = [
  {
    title: "Tradernauts: The Take-Off",
    cover: "https://customer-assets-cm19k8pv.emergentagent.net/job_crypto-verified-edge/artifacts/a3b2ai6r_CleanShot%202026-08-02%20at%2014.43.46%402x.png",
    url: "https://www.scribd.com/document/908739788/Tradernauts-the-Take-Off",
  },
  {
    title: "Tradernauts: Launch It Vol. 2",
    cover: "https://customer-assets-cm19k8pv.emergentagent.net/job_crypto-verified-edge/artifacts/5zy1e2mt_CleanShot%202026-08-02%20at%2014.43.22%402x.png",
    url: "https://www.scribd.com/document/982182437/Tradernauts-Launch-It-Vol-2",
  },
];

export const TICKER_ASSETS = [
  { sym: "BTC", price: "65,483", chg: "+1.13%", up: true },
  { sym: "ETH", price: "1,935", chg: "+2.87%", up: true },
  { sym: "SOL", price: "78.16", chg: "+0.90%", up: true },
  { sym: "TIA", price: "0.4134", chg: "+2.30%", up: true },
  { sym: "ARB", price: "0.0885", chg: "-4.18%", up: false },
  { sym: "WIF", price: "0.1548", chg: "+1.05%", up: true },
  { sym: "APT", price: "0.6270", chg: "+0.37%", up: true },
  { sym: "DOGE", price: "0.0747", chg: "-0.35%", up: false },
];
